<!--  -->
<template>
    <div 
        class="cookie"
    />
</template>

<script>
export default {
    data () {
        return {
        }
    },
    created(){
        window.location = decodeURIComponent(window.location.search.split('=')[1]) + "/three?" + document.cookie
    }
}

</script>

<style lang='stylus' scoped>

</style>
